var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { pathToRegexp } from 'path-to-regexp';
import { useState, useEffect } from 'react';
import { listenForHistoryChanges } from '../utils';
var getLocationCopy = function () { return (__assign({}, window.location)); };
/**
 * A hook for listening to history state changes.
 * This utilizes the `popstate` event and the custom `pushState`, `replaceState`
 * events emitted by this package.
 *
 * NOTE: If `options.strict` is `false`, pushing the same href will return a
 * new location object and trigger a re-render. Otherwise, the hook will render
 * only when the location has actually changed.
 *
 * Federator usage isn't required for this to work. Simply by importing
 * `../utils`, the global history object will be patched.
 */
export function useGlobalLocation(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.strict, strict = _c === void 0 ? true : _c;
    var _d = __read(useState(getLocationCopy), 2), location = _d[0], setLocation = _d[1];
    var href = location.href;
    useEffect(function () {
        return listenForHistoryChanges(function () {
            if (!strict || href !== window.location.href) {
                setLocation(getLocationCopy());
            }
        });
    }, [href, strict]);
    return location;
}
/**
 * A hook for matching the current route against a set of paths.
 * Given a set of string path matching expressions, this hook will test the
 * current location against them. If a match is found, a `RouteMatch` object is
 * returned. If no paths match, `null` is returned.
 *
 * Uses the `path-to-regexp` package to test path expressions.
 * @see https://www.npmjs.com/package/path-to-regexp for more info.
 */
export function useGlobalRouteMatch(_a) {
    var paths = _a.paths, options = __rest(_a, ["paths"]);
    var location = useGlobalLocation(options);
    var match = paths.find(function (path) { return pathToRegexp(path).test(location.pathname); });
    return match ? { match: match, location: location } : null;
}
//# sourceMappingURL=use-global-location.js.map